<script lang="ts">
  import { get } from 'svelte/store'
  import { pageStore } from '@packages/stores'
  import { Pages } from '@packages/utils/enums'
  import { NavMenu } from '@packages/ui'
  import { configStore } from '@src/stores'

  const config = get(configStore)
  const isWalletAssetsConfigured = !!config.walletAssets?.length

  const handleNavigate = (page: Pages) => {
    pageStore.set(page)
  }
</script>

<NavMenu
  options={{
    onClick: handleNavigate,
    showAssets: isWalletAssetsConfigured,
  }}
/>
